import { createActionGroup, emptyProps, props } from "@ngrx/store";

import { BulkEditCalendarEventMutation, JobDetailsV2Fragment, UpdateJobMutation } from "../../../generated/graphql.generated";
import { ActionSource } from "../../state/action-sources";

import { ActionType, ContinueButtonCommand } from "./cancel-and-close-dialog.state";

export const CancelAndCloseDialogActions = createActionGroup({
  source: ActionSource.CANCEL_AND_CLOSE_DIALOG,
  events: {
    'Open Cancel And Close Dialog Triggered': props<{ jobId: string; trigger: ActionType; eventIds?: string[] }>(),
    'Fetch Job Success': props<{ job: JobDetailsV2Fragment }>(),
    'Fetch Job Error': props<{ error: Error }>(),
    'Event Card Clicked': props<{ eventId: string }>(),
    'Continue Button Clicked': props<{ command: ContinueButtonCommand }>(),
    'Closure Reason Selected': props<{ closedReason: string }>(),
    'Cancel Events Only Button Clicked': emptyProps(),
    'Close Job Button Clicked': emptyProps(),
    'Back Button Clicked': emptyProps(),
    'Cancel Events Success': props<{
      updatedEvents: BulkEditCalendarEventMutation['bulkEditCalendarEvent']['events'];
      jobId: string;
    }>(),
    'Cancel Events Error': props<{ error: Error }>(),
    'Cancel And Close Success': props<{ updatedJob: UpdateJobMutation['updateJobs']['jobs'][0] }>(),
    'Cancel And Close Error': props<{ error: Error }>(),
    'Exit Button Clicked': emptyProps(),
  },
});
